// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-96f9c8da] .b-form-tags-button {\n  min-width: initial;\n}\n[data-v-96f9c8da] .b-form-tag-content {\n  font-size: 1.35em;\n}\n", ""]);
// Exports
module.exports = exports;
